export const styleModal = {
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: 0,
  bgcolor: "background.paper",
  boxShadow: 24,
};
